import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const InputContainer = styled.div`
  padding: 8px 0px;
`

export const Suggestion = styled.div`
  color: ${Colors.GS600};
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0.14px;
`

export const Error = styled.div`
  color: ${Colors.R300};
`
